export default "__VITE_ASSET__CfhcW891__"